import { Icon, type IconName } from './icon';
import { CATEGORY, type Category } from './category';

/** Category-tinted rounded icon tile (launcher / list rows). Renders the
 *  category illustration when a category is given with no icon override,
 *  otherwise falls back to the inline SVG glyph. */
export function LeadIcon({
  category,
  icon,
  size = 46,
}: {
  category?: Category;
  icon?: IconName;
  size?: number;
}) {
  const meta = category ? CATEGORY[category] : undefined;
  const cls = meta?.cls ?? '';

  if (meta && !icon) {
    // Full-bleed colorful tile — the illustration carries its own tinted
    // background, so it fills the rounded frame edge to edge.
    return (
      <div className={`wb-leadicon wb-leadicon--img ${cls}`} style={{ width: size, height: size }}>
        <img
          src={meta.img}
          alt=""
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </div>
    );
  }

  const name = icon ?? meta?.icon ?? 'sparkle';
  return (
    <div className={`wb-leadicon ${cls}`} style={{ width: size, height: size }}>
      <Icon name={name} size={Math.round(size * 0.5)} />
    </div>
  );
}
